import type { SVGAttributes } from 'react';

export function NederlandsIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_472_2186)">
				<path
					d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
					fill="#F0F0F0"
				/>
				<path
					d="M7.9985 0C4.55878 0 1.62644 2.171 0.496094 5.21741H15.5009C14.3706 2.171 11.4382 0 7.9985 0Z"
					fill="#A2001D"
				/>
				<path
					d="M7.9985 16C11.4382 16 14.3706 13.829 15.5009 10.7826H0.496094C1.62644 13.829 4.55878 16 7.9985 16Z"
					fill="#0052B4"
				/>
			</g>
			<defs>
				<clipPath id="clip0_472_2186">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
